module.exports = __webpack_public_path__ + "img/Message.bd7900a8.svg";